import { z } from "zod";
import { uuidSchema } from "../../../utils/uuid";
import { ruleStatusSchema, typeLimitSchema } from "./_shared";
import { updatedBySchema } from "../../../common/database";
import { merchantGroupSchema } from "../../shared";

export const ruleSchema = z.object({
  uuid: uuidSchema,
  company: uuidSchema,
  name: z.string(),
  onlyFrance: z.boolean(),
  nationalHolidays: z.boolean(),
  amountLimit: z.number(),
  typeLimit: typeLimitSchema,
  areOtherMerchantsAuthorized: z.boolean(),
  unauthorizedMerchantGroups: z.array(merchantGroupSchema),
  areSupportingDocumentsMandatory: z.boolean(),
  vehicleHasToScan: z.boolean(),
  canPayOnline: z.boolean(),
  status: ruleStatusSchema,
  deletedAt: z.date().nullable(),
  updatedBy: updatedBySchema.optional(),
  deletedBy: updatedBySchema.optional(),
  createdAt: z.date().optional(),
});

export type Rule = z.infer<typeof ruleSchema>;
